// import { useEffect, useCallback } from 'react';
// import { Auth } from 'aws-amplify';
// import { useNavigate } from 'react-router-dom';

// export const useSessionHandler = () => {
//     const navigate = useNavigate();

//     const handleLogout = useCallback(async () => {
//         try {
//             // Check if user is authenticated before attempting logout
//             const currentUser = await Auth.currentAuthenticatedUser();
//             if (currentUser) {
//                 await Auth.signOut({ global: true });
//                 localStorage.clear();
//                 sessionStorage.clear();
//                 navigate('/', { replace: true });
//             }
//         } catch (error) {
//             console.log('No authenticated user to logout');
//             // Don't navigate if there's no user to logout
//         }
//     }, [navigate]);

//     useEffect(() => {
//         let isSubscribed = true; // For cleanup

//         // Handle browser close/refresh
//         const handleBeforeUnload = async (event) => {
//             if (isSubscribed) {
//                 event.preventDefault();
//                 event.returnValue = '';
//                 await handleLogout();
//             }
//         };

//         // Handle visibility change (tab close/switch)
//         const handleVisibilityChange = async () => {
//             if (isSubscribed && document.visibilityState === 'hidden') {
//                 await handleLogout();
//             }
//         };

//         // Add event listeners
//         window.addEventListener('beforeunload', handleBeforeUnload);
//         document.addEventListener('visibilitychange', handleVisibilityChange);

//         // Cleanup function
//         return () => {
//             isSubscribed = false;
//             window.removeEventListener('beforeunload', handleBeforeUnload);
//             document.removeEventListener('visibilitychange', handleVisibilityChange);
//         };
//     }, [handleLogout]);

//     return { handleLogout };
// };

import { useEffect, useCallback } from 'react';
import { Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';

export const useSessionHandler = () => {
    const navigate = useNavigate();

    const handleLogout = useCallback(async () => {
        try {
            const currentUser = await Auth.currentAuthenticatedUser();
            if (currentUser) {
                await Auth.signOut({ global: true });
                localStorage.clear();
                sessionStorage.clear();
                navigate('/', { replace: true });
            }
        } catch (error) {
            console.log('No authenticated user to logout');
        }
    }, [navigate]);

    const refreshSession = useCallback(async () => {
        try {
            const session = await Auth.currentSession();
            if (session && session.isValid()) {
                return true;
            }
            return false;
        } catch (error) {
            console.log('Error checking session:', error);
            return false;
        }
    }, []);
    const normalLogin = useCallback(async (username, password) => {
        try {
            const user = await Auth.signIn(username, password);
            // Optionally, you can store user info in local storage or state
            console.log('Login successful:', user);
            navigate('/dashboard', { replace: true }); // Redirect to dashboard after login
        } catch (error) {
            console.error("Error during normal login:", error);
            throw error; // Rethrow the error for handling in the component
        }
    }, [navigate]);
    useEffect(() => {
        let isSubscribed = true;

        const handleBeforeUnload = async (event) => {
            if (isSubscribed) {  // Check if still subscribed
                const shouldPrevent = await refreshSession();
                if (shouldPrevent) {
                    event.preventDefault();
                    event.returnValue = '';
                }
            }
        };

        // Modified visibility change handler
        const handleVisibilityChange = async () => {
            if (isSubscribed && document.visibilityState === 'visible') {  // Check if still subscribed
                await refreshSession();
            }
        };

        // Periodic session refresh
        const refreshSessionIfSubscribed = async () => {
            if (isSubscribed) {  // Check if still subscribed
                await refreshSession();
            }
        };

        // Add event listeners
        window.addEventListener('beforeunload', handleBeforeUnload);
        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Set up periodic session refresh
        const sessionRefreshInterval = setInterval(refreshSessionIfSubscribed, 5 * 60 * 1000);

        // Cleanup function
        return () => {
            isSubscribed = false;
            window.removeEventListener('beforeunload', handleBeforeUnload);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            clearInterval(sessionRefreshInterval);
        };
    }, [handleLogout, refreshSession]);

    return { handleLogout, normalLogin };
};

